module.exports = __webpack_public_path__ + "static/media/face5.cafb092e.jpg";